import React, { useState } from 'react';
import SelectBox from '../../../UI/SelectBox';
import { Salutation } from '../../../../Constants/Constants';
import TextField from '../../../UI/TextField';
import { nameValidate, slideValidation } from '../../../../Utility/Validations';
import GTMDataLayer from '../../../../Utility/GTMDataLayer';

const PersonalDetails = (props) => {
	const handlePersonalDetails = async(e) => {
		var name = document.getElementById('txtFName');
		const validationArr = ['lstSalutation', 'txtFName', 'txtLName'];
    const validationCheck = await slideValidation(validationArr, props.trigger);
    if (validationCheck == 'Success') {
		GTMDataLayer({
            clickEvent: 'slideclick',
            question: 'legal name',
            answer: '',
          });
      props.slideChange(e);
    }
	};
	return (
		<div className={props.slideStatus}>
         <label class="mt-3 mb-2"  style={{fontSize:"18px",textAlign:"center"}} htmlFor="Date of Birt">Please confirm the Beneficiary</label>			
		 <SelectBox
				className="w-100  form-select"
				OptionValue={Salutation}
				id="lstSalutation"
				onChange={() => props.clearErrors('lstSalutation')}
				clearErrors={props.clearErrors}
				register={props.register('lstSalutation', {
					required: 'Please Select Title',
				})}
				validationMsg={
					props.validationMsg.lstSalutation &&
					props.validationMsg.lstSalutation.message
				}
			/>
			<TextField
				type="text"
				className="date-of-b"
				placeholder="First Name"
				id="txtFName"
				autoComplete="off"
				maxLength="20"
				onKeyPress={(e) => {nameValidate(e);props.clearErrors(`txtFName`)}}
				register={props.register('txtFName', {
					required: 'Please Enter First Name',
					minLength: {
						value: 3,
						message: 'Please Enter Valid First Name',
					},
					pattern: {
						value: /^[a-zA-Z\s]+$/,
						message: 'Your Name is Invalid. Please Recheck',
					},
				})}
				validationMsg={props.validationMsg.txtFName?.message}
			/>
			<TextField
				type="text"
				className="date-of-b"
				placeholder="Last Name"
				id="txtLName"
				autoComplete="off"
				maxLength="20"
				onKeyPress={(e) => {nameValidate(e);props.clearErrors(`txtLName`)}}
				register={props.register('txtLName', {
					required: 'Please Enter Last Name',
					minLength: {
						value: 3,
						message: 'Please Enter Valid Last Name',
					},
					pattern: {
						value: /^[a-zA-Z\s]+$/,
						message: 'Your Name is Invalid. Please Recheck',
					},
				})}
				validationMsg={props.validationMsg.txtLName?.message}
			/>
			<button type="button" className="next-btn" name="next4" onClick={handlePersonalDetails}>Next</button>
		</div>
	);
};

export default PersonalDetails;